/**
 * Shows a card-reader prompt only while it is still the latest message from this
 * attempt. A translation that finishes late must not replace a newer prompt.
 * retry() drops any prompt already in flight. Callers still translate every
 * message, so a late answer can be cached; this only skips applying it.
 */
export function createLatestCardReaderDisplay(show: (text: string) => void) {
	let latestMessage: string | null = null;
	let generation = 0;

	return {
		begin(msg: string) {
			latestMessage = msg;
			const messageGeneration = generation;
			return (text: string) => {
				if (latestMessage !== msg || generation !== messageGeneration) return;
				show(text);
			};
		},
		retry() {
			generation += 1;
			latestMessage = null;
		},
	};
}

/**
 * Show callback for one reader sentence. An ignored sentence must not call begin,
 * or it becomes the latest message and a translation still in flight is dropped.
 */
export function createCardReaderShowCallback(display: ReturnType<typeof createLatestCardReaderDisplay>, msg: string, isIgnored: boolean | undefined) {
	if (isIgnored) return () => undefined;
	return display.begin(msg);
}
